import { getPipelineStage } from "../../modules/talentPipeline/utils/pipelineEngine";

export function buildTalentPipeline(users = []) {
  return (users || [])
    .filter((u) => {
      const role = String(
        u.platformRole ||
          u.role ||
          u.userType ||
          ""
      ).toLowerCase();

      const workerType = String(
        u.position ||
          u.primaryRole ||
          u.workerType ||
          u.roleType ||
          ""
      ).toLowerCase();

      return (
        role === "worker" &&
        !["planner", "admin", "owner_admin", "facility_admin_viewer"].includes(workerType)
      );
    })
    .map((u) => {
      const registrationStatus = String(u.registrationStatus || "").toLowerCase();
      const workerStatus = String(u.workerStatus || "").toLowerCase();
      const status = String(u.status || "").toLowerCase();

      let pipelineStage = getPipelineStage(u);

      if (
        registrationStatus === "pending" ||
        workerStatus === "registration_pending" ||
        status === "pending_registration_approval"
      ) {
        pipelineStage = "registered";
      }

   console.log("PIPELINE", {
  email: u.email,
  onboardingStatus: u.onboardingStatus,
  complianceStatus: u.complianceStatus,
  workerStatus: u.workerStatus,
  status: u.status,
  pipelineStage,
});

return {
  ...u,
  pipelineStage,
  source:
    u.source ||
    u.registrationSource ||
    u.recruitmentSource ||
    "manual_invite",
};
    });
}